import type { SalesChecklistItem } from "@expert/contentful";

import type { OfferChecklistState } from "@/sales-tools/home-product/stores/useOfferChecklistStore";

export const isSectionComplete = (
    checklistItems: SalesChecklistItem[],
    checkedItems: OfferChecklistState["data"],
): boolean => {
    const allKeysInChecklistSection = checklistItems.map((item) => item.key);
    return allKeysInChecklistSection.every((key) => (checkedItems as Partial<Record<string, boolean>>)[key] ?? false);
};
